import { render, staticRenderFns } from "./PoiContactPerson.vue?vue&type=template&id=3a36c58b"
import script from "./PoiContactPerson.js?vue&type=script&lang=js&external"
export * from "./PoiContactPerson.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports